// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28SDs","right":"styles_right__1Ufwp"};